module.exports = __webpack_public_path__ + "media/vidos.fd2dadd0.mp4";